import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "memberInput",
    "plansContainer",
    "monthlyPrice", 
    "yearlyPrice",
    "monthlyBreakdown",
    "yearlyBreakdown", 
  ]
  
  static values = { clubId: Number }

  connect() {
    this.initializeMemberCount()
    this.updatePricing()
  }
  
  initializeMemberCount() {
    // Check if member_count is in URL parameters and update input if so
    const urlParams = new URLSearchParams(window.location.search)
    const memberCountFromUrl = urlParams.get('member_count')
    
    if (memberCountFromUrl && this.memberInputTarget) {
      const memberCount = parseInt(memberCountFromUrl)
      if (memberCount > 0) { this.memberInputTarget.value = memberCount }
    }
  }

  updatePricing() {
    let memberCount = parseInt(this.memberInputTarget.value) || 1
    const planPricingRows = document.querySelectorAll('.plan-pricing[data-plan]')

    let errorEl = this.memberInputTarget.closest('.row').querySelector('.member-count-error')
    if (errorEl) { errorEl.remove(); }  

    const minMembers = parseInt(this.memberInputTarget.dataset.minimal)
    if (memberCount < minMembers) { 
      memberCount = minMembers;    

      errorEl = document.createElement('div')
      errorEl.className = 'row member-count-error mt-1'
      errorEl.style.color = 'red'
      errorEl.style.fontSize = '0.9em'
      errorEl.textContent = `Minimalni broj članova za vašu licencu je ${minMembers} - broj članova u društvu.`
      this.memberInputTarget.closest('.row').appendChild(errorEl)
    }
    
    planPricingRows.forEach(planElement => {
      const planKey = planElement.dataset.plan
      const basePrice = parseFloat(planElement.dataset.basePrice) || 0
      const perMemberPrice = parseFloat(planElement.dataset.perMemberPrice) || 0
      
      if (!planKey) return
      
      // Calculate prices
      const monthlyTotal = basePrice + (perMemberPrice * memberCount)
      const yearlyTotal = (monthlyTotal * 12 * 0.85) // 15% discount
      
      // Update monthly price
      const monthlyPriceEl = document.querySelector(`[data-club-pricing-target="monthlyPrice"][data-plan="${planKey}"]`)
      if (monthlyPriceEl) {
        monthlyPriceEl.textContent = `€${monthlyTotal.toFixed(2)}`
      } else {
        console.log(`Monthly price element not found for ${planKey}`)
      }
      
      // Update yearly price
      const yearlyPriceEl = document.querySelector(`[data-club-pricing-target="yearlyPrice"][data-plan="${planKey}"]`)
      if (yearlyPriceEl) {
        yearlyPriceEl.textContent = `€${yearlyTotal.toFixed(2)}`
      } else {
        console.log(`Yearly price element not found for ${planKey}`)
      }
      
      // Update breakdown text
      if (perMemberPrice > 0 && memberCount > 0) {
        const monthlyMemberCost = (perMemberPrice * memberCount)
        const yearlyMemberCost = (monthlyMemberCost * 12 * 0.85)
        
        const monthlyBreakdownEl = document.querySelector(`[data-club-pricing-target="monthlyBreakdown"][data-plan="${planKey}"]`)
        if (monthlyBreakdownEl) {
          monthlyBreakdownEl.textContent = `${basePrice}€ + ${monthlyMemberCost.toFixed(2)}€ (${memberCount} × ${perMemberPrice}€)`
        }
        
        const yearlyBreakdownEl = document.querySelector(`[data-club-pricing-target="yearlyBreakdown"][data-plan="${planKey}"]`)
        if (yearlyBreakdownEl) {
          const baseYearly = (basePrice * 12 * 0.85).toFixed(2)
          yearlyBreakdownEl.textContent = `${baseYearly}€ + ${yearlyMemberCost.toFixed(2)}€ (${memberCount} × ${perMemberPrice}€/mj)`
        }
      }
    })
    
    this.updateOfferLinks(memberCount)
  }
  
  updateOfferLinks(memberCount) {
    const offerLinks = document.querySelectorAll('a[href*="request_offer"]')
    
    offerLinks.forEach(link => {
      try {
        const url = new URL(link.href)
        url.searchParams.set('member_count', memberCount)
        link.href = url.toString()
      } catch (error) {
        console.error(`Error updating offer link: ${error.message}`)
      }
    })
  }
}
